import React, { useEffect } from "react";
import { useTopToolbar } from "../context/TopToolbarContext";

const Home = () => {
  const { setToolbar, clearToolbar } = useTopToolbar();

  /*
  useEffect(() => {
    const btn = (
      <button className="btn-primary" onClick={() => alert('Home button clicked')}>
        Home Action
      </button>
    );
    setToolbar({ right: btn });
    return () => clearToolbar();
  }, [setToolbar, clearToolbar]);
  */

  return (
    <div className="home-container flex flex-col items-center justify-center min-h-screen bg-gradient-to-br from-white via-gray-100 to-gray-200">
      <p>Welcome to Your Workspace</p>
      <p>Here is your main workspace content</p>
    </div>
  );
};

export default Home;
